import { render, staticRenderFns } from "./index.vue?vue&type=template&id=760e8ce9"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=760e8ce9&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('760e8ce9')) {
      api.createRecord('760e8ce9', component.options)
    } else {
      api.reload('760e8ce9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=760e8ce9", function () {
      api.rerender('760e8ce9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/community/classification/index.vue"
export default component.exports